import React, { useState } from "react";
import { Request } from "../../api/auth/Register.api";
import RegisterView from "../../views/auth/RegisterView";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import Success from "../../components/Success";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

const initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  username: "",
  password: "",
  confirm_password: "",
  telephone_number: "",
  cellular_number: "",
  fax_number: "",
  street: "",
  city: "",
  district: "",
  country: "",
  cap: "",
  vat_number: "",
  terms_and_conditions: false,
};

const RegisterContainer = ({ type }) => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();

  const onRegisterNewInstaller = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.registerInstaller(values)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onRegisterNewCustomer = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.registerCustomer(values)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = (data, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setSuccess(true);
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  const onCloseSuccesPopup = () => {
    setSuccess(null);
    history.goBack();
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      {success ? (
        <Success
          message={t("register.success.message")}
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      <RegisterView
        type={type}
        initialValues={initialValues}
        onRegisterNewInstaller={onRegisterNewInstaller}
        onRegisterNewCustomer={onRegisterNewCustomer}
      />
    </>
  );
};

export default RegisterContainer;
